import BaseList from './BaseList'

export default {
  name: 'BaseListEditor',
  extends: BaseList,
  data () {
    return {
      operator: '',
      editorOpened: false,
      refEditorName: 'editor'
    }
  },
  methods: {
    getEditor () {
      return this.$refs[this.refEditorName]
    },
    onOpenEditor (model) {
      let refEditor = this.getEditor()
      refEditor && refEditor.open(model)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/BaseListEditor.js